import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
// Replace with your actual Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyDxxK0ce-qZrIJ3AG4QWmOG7gircXMW-to",
  authDomain: "fastro-blog.firebaseapp.com",
  projectId: "fastro-blog",
  storageBucket: "fastro-blog.firebasestorage.app",
  messagingSenderId: "549039682933",
  appId: "1:549039682933:web:87effdacea5d2f9f91cf3c",
  measurementId: "G-YXWCWKD3GC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

export default app;
